module.exports = "/static/assets/86e15532bf675c4c67915038996b3bf7.gif";